import _ from 'lodash';
import { SpecPathValue } from './SpecPathValue';
import { useContext } from 'react';
import LegoAdminPageContext from '../../legoAdminPageContext';
import { SchemaChangeOpsList } from './SchemaChangeOpsList';
import ExplainWithAIButton from './ExplainWithAIButton';


export default function SpecsSchemaChangePreview({selection = null, onSelectionChange = null, changes, usage}) {
  const {page} = useContext(LegoAdminPageContext);

  return <div>  
    <div className={'p-1 bg-white'} style={{fontSize: '15px'}}>
      <SchemaChangeOpsList selection={selection} onSelectionChange={onSelectionChange} ops={changes}/>
    </div>


    {_.map(usage, (specs, text) => <div key={text} className={'mt-2'}>
      <div className={'d-flex align-items-center'}>
        <ExplainWithAIButton text={text} />

        <span className={'small'}>
            "{text}"
          </span>
      </div>

      <div>
        <div className={'py-1 px-3 rounded monospace small break-word-all'} style={{backgroundColor: '#ddd'}}>
          {specs.map(([path, value]) => <SpecPathValue key={path} path={path} value={value}/>)}
        </div>
      </div>
    </div>)}
  </div>
}
